import { useState } from "react";
import type { AnimalTrack, PhenomenonCard } from "../types/telemetry";

type PhenomenonPanelProps = {
  animals?: AnimalTrack[];
  items: PhenomenonCard[];
};

export function PhenomenonPanel({ animals = [], items }: PhenomenonPanelProps) {
  const [activeSource, setActiveSource] = useState<string | null>(null);
  const animalSourceId = "source-animals";

  return (
    <div className="phenomenon-list">
      {items.map((item) => (
        <article
          className={`phenomenon-card phenomenon-card-${item.kind} phenomenon-card-${item.dataStatus ?? "mock"}`}
          key={item.title}
        >
          <div className="phenomenon-kicker-row">
            <p className="phenomenon-kicker">{item.title}</p>
            <button
              aria-expanded={activeSource === item.kind}
              aria-label={`${item.title}の情報の取得元`}
              className="source-button"
              type="button"
              onClick={() => setActiveSource(activeSource === item.kind ? null : item.kind)}
            >
              ?
            </button>
            {activeSource === item.kind && <p className="source-popover">{item.source}</p>}
          </div>
          <p className="phenomenon-message">{item.message}</p>
          <p className="phenomenon-inline-stats">
            {item.stats.map((stat) => (
              <span key={stat.label}>
                {stat.label}
                <strong>{stat.value}</strong>
              </span>
            ))}
          </p>
          <p className="phenomenon-detail">{item.detail}</p>
        </article>
      ))}

      {animals.length > 0 && (
        <article className="phenomenon-card phenomenon-card-animals phenomenon-card-mock">
          <div className="phenomenon-kicker-row">
            <p className="phenomenon-kicker">生き物</p>
            <button
              aria-expanded={activeSource === animalSourceId}
              aria-label="生き物の情報の取得元"
              className="source-button"
              type="button"
              onClick={() => setActiveSource(activeSource === animalSourceId ? null : animalSourceId)}
            >
              ?
            </button>
            {activeSource === animalSourceId && (
              <p className="source-popover">無料API候補: Movebank。公開データだけを使用。</p>
            )}
          </div>
          <p className="phenomenon-message">海と空を移動する生き物を重ねています。</p>
          <p className="phenomenon-inline-stats">
            {animals.map((animal) => (
              <span key={animal.id}>
                {animal.name}
                <strong>{animal.note}</strong>
              </span>
            ))}
          </p>
          <p className="phenomenon-detail">今は無料公開データ風のモックです。あとでMovebankなどの公開データに差し替えます。</p>
        </article>
      )}
    </div>
  );
}
